export default __webpack_public_path__ + "locales/pt/VersionHistory.json?hash=674c240a1f4ddbaf4c71f8330fd33975";